import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Delivery = createSvgIcon(
  <path d="M0 2.25h13.5v3h5.003l.838 3.35 3.622 1.812A1.875 1.875 0 0 1 24 12.088v6.662h-3.27a3.376 3.376 0 0 1-6.72-.125H9.74a3.375 3.375 0 0 1-6.72.125H0V2.25Zm14.656 14.125A3.37 3.37 0 0 1 17.375 15c1.17 0 2.201.595 2.807 1.5h1.568v-4.18l-4.34-2.17-.663-2.65H13.5v8.875h1.156Zm-3.406 0V4.5h-9v12h1.318A3.372 3.372 0 0 1 6.375 15a3.37 3.37 0 0 1 2.719 1.375h2.156Z" />,
  'Delivery'
);

export { Delivery };